import fetcher from 'api/fetcher';

import urlParser from 'bloko/common/urlParser';

import { CountsCampaign, setCountsCampaign } from 'store/autoReducers';
import { AppThunkAction } from 'store/utils';

export const fetchCampaignsCount = (abortSignal?: AbortSignal): AppThunkAction => {
    return (dispatch, getState) => {
        const { campaignSearchValue, appliedFilters } = getState().dashboard;

        const queryStr = urlParser.stringify({
            nameFilter: campaignSearchValue,
            productType: appliedFilters.productTypes || null,
            campaignStatus: appliedFilters.campaignStatuses || null,
            budgetStatus: appliedFilters.budgetStatuses || null,
            moderationStatus: appliedFilters.moderationStatuses || null,
            area: appliedFilters.areas || null,
            professionalRoles: appliedFilters.professionalRoles || null,
            createdByUserIds: appliedFilters.createdByUserIds || null,
        });

        return fetcher
            .get<unknown, CountsCampaign>(`/api/v1/account/campaigns/count?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((count) => {
                dispatch(setCountsCampaign(count));
            });
    };
};
